import styled from 'styled-components';
import { AdPlacement, IAdSpacing } from './types';
import { media, layout } from 'src/components/base';

export interface IAdSkeleton {
  $placement: AdPlacement;
  $spacing: IAdSpacing | undefined;
}

export interface IAdLabel {
  $align?: 'top' | 'bottom';
}

export const AdLabel = styled.span<IAdLabel>`
  position: absolute;
  z-index: 1;
  pointer-events: none;
  left: 0;
  ${props => props.$align || 'top'}: 0;
  display: block;
  background-color: ${props => props.theme.colors.base200};
  color: ${props => props.theme.colors.base600};
  font-size: 11px;
  padding: 0 ${layout.measurements.spacing025};
`;

export const AdContainerSkeleton = styled.div<IAdSkeleton>`
  margin-top: ${props => props.$spacing?.top ?? 0};
  margin-bottom: ${props => props.$spacing?.bottom ?? 0};

  min-height: ${props => {
    return getHeightFromPlacementMobile(props.$placement);
  }};

  ${media.mediumUp<IAdSkeleton>`
    min-height: ${props => {
      return getHeightFromPlacementDesktop(props.$placement);
    }}};
  `};

  ${media.mediumDown`
    margin-top: 0px;
    margin-bottom: 0px;
  `}
`;

function getHeightFromPlacementDesktop(
  placement: AdPlacement | undefined
): string {
  if (!placement) {
    return 'auto';
  }
  switch (placement) {
    case 'panorama_top':
    case 'panorama_extra':
    case 'panorama_extra_2':
      return '120px';
    case 'dubbelpanorama1':
    case 'dubbelpanorama2':
    case 'dubbelpanorama3':
    case 'mob-banner-ad-a':
    case 'mob-banner-ad-b':
    case 'skyscraper_1':
    case 'skyscraper_2':
    case 'skyscraper_3':
    case 'panorama_target':
    default:
      return 'auto';
  }
}

function getHeightFromPlacementMobile(
  placement: AdPlacement | undefined
): string {
  if (!placement) {
    return 'auto';
  }
  switch (placement) {
    case 'dubbelpanorama1':
    case 'dubbelpanorama2':
    case 'dubbelpanorama3':
    case 'dubbelpanorama_top':
      return '160px;';
    case 'panorama_top':
    case 'mob-banner-ad-a':
    case 'mob-banner-ad-b':
    case 'skyscraper_1':
    case 'skyscraper_2':
    case 'skyscraper_3':
    case 'panorama_target':
    case 'panorama_extra':
    case 'panorama_extra_2':
    default:
      return 'auto';
  }
}
